import { NavLink } from "react-router-dom";
import UseFetch from "../components/UseFetch";
import { Loading, decryptData, defaulUrl, impression } from "../components/const";
import { useRef, useState, useEffect } from "react";
import Swal from "sweetalert2";
import $ from "jquery";

const Approvisions = () => {
    let { data: approvisions, isloading } = UseFetch("approvisions/liste/0");
    const [etat, setEtat] = useState("tous");
    const [date1, setDate1] = useState(null);
    const [date2, setDate2] = useState(null);
    const [trieapprov, setTrie] = useState(null);
    const [idappro, setIdAppro] = useState(null);
    const tableRef = useRef(null);

    const user = decryptData("USER");
    const profile = decryptData("user_profile");
    const isadmin =
        user?.droit === "Administrateur" || user?.droit === "Comptable";

    // Filtrer par magasin si pas admin
    if (approvisions) {
        approvisions = isadmin
            ? approvisions
            : approvisions.filter((prod) => +prod.idmag === +profile.idmagasin);
    }

    // Initialiser DataTable une seule fois
    useEffect(() => {
        if (tableRef.current) {
            $(tableRef.current).DataTable();
        }
    }, [approvisions]);

    const handleValider = (id, opration) => {
        Swal.fire({
            title: "Confirmez votre opération",
            text: "Souhaitez-vous vraiment appliquer cette opération ?",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "OUI",
            cancelButtonText: "NON",
            confirmButtonColor: "green",
        }).then((rep) => {
            if (rep.isConfirmed) {
                fetch(`${defaulUrl}approvisions/${opration}/${id}`, {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${decryptData("ACCESS_TOKEN")}`,
                    },
                })
                    .then((response) => response.json())
                    .then((data) => {
                        Swal.fire({
                            title: "Succès",
                            text: data.message,
                            icon: "success",
                            timer: 5000,
                        });
                    });
            }
        });
    };

    const handleTriByDate = (e) => {
        e.preventDefault();
        if (!date1 || !date2) {
            Swal.fire({
                title: "Date(s) invalides!",
                text: "Choisissez de bonnes dates pour date1 et date2",
                icon: "error",
                toast: true,
                position: "center",
                color: "white",
                iconColor: "white",
                background: "red",
            });
            return;
        }

        setTrie(
            approvisions.filter(
                (appro) => appro.created_at >= date1 && appro.created_at <= date2 + 1
            )
        );
    };

    // Trier les approvisions par statut
    const listAppro = (trieapprov ?? approvisions)?.sort(
        (a, b) => a.statut - b.statut
    );

    return (
        <div className="Approvisions container-fluid">
            <div className="row my-2">
                <div className="col-lg-8 h3 text-primary">
                    LISTE DES APPROVISIONNEMENTS
                </div>
                {isadmin && (
                    <div className="col-lg-4 text-end">
                        <NavLink
                            to="/approvisions/add"
                            type="button"
                            className="btn btn-sm btn-primary"
                        >
                            Nouv. Appro
                        </NavLink>
                    </div>
                )}
            </div>

            {isloading ? (
                <Loading />
            ) : listAppro?.length ? (
                <div className="row">
                    {/* Filtres */}
                    <div className="row align-items-center mb-2">
                        <div className="col-lg-5 d-flex gap-1">
                            <div className="form-group col-4">
                                <input
                                    type="date"
                                    className="form-control"
                                    id="date1"
                                    name="date1"
                                    value={date1 ?? ""}
                                    onChange={(e) => setDate1(e.target.value)}
                                />
                            </div>
                            <div className="form-group col-4">
                                <input
                                    type="date"
                                    className="form-control"
                                    id="date2"
                                    name="date2"
                                    value={date2 ?? ""}
                                    onChange={(e) => setDate2(e.target.value)}
                                />
                            </div>
                            <button
                                onClick={handleTriByDate}
                                type="submit"
                                className="btn btn-sm btn-primary col-2 align-self-end"
                            >
                                <i className="bx bx-search"></i>
                            </button>
                        </div>
                    </div>

                    {/* Tableau */}
                    <div className="table-responsive">
                        <table
                            ref={tableRef}
                            className="table table-striped table-hover table-white table-bordered border-primary"
                        >
                            <thead className="table-dark border-primary">
                                <tr className="text-center">
                                    <th>N°</th>
                                    <th>NUM-APPRO</th>
                                    {isadmin && <th>MAGASIN</th>}
                                    <th>CONTENEUR</th>
                                    <th>DATE APPRO</th>
                                    <th>STATUT</th>
                                    <th className="text-end">ACTIONS</th>
                                </tr>
                            </thead>
                            <tbody className="plage">
                                {listAppro.map((appro, index) => (
                                    <tr key={index + 1} className="conteneur">
                                        <td>{index + 1}</td>
                                        <td>{appro.numero}</td>
                                        {isadmin && <td>{appro.magasin}</td>}
                                        <td className="critere">{appro.conteneur}</td>
                                        <td>{appro.created_at}</td>
                                        <td>{appro.statut ? "Validé" : "En attente"}</td>
                                        <td className="text-end">
                                            {isadmin && (
                                                <>
                                                    <NavLink title="Confirmer"
                                                        to="/confirmation"
                                                        state={{ appro }}
                                                        className="btn btn-sm btn-success m-1"
                                                    >
                                                        <i className="bx bx-check-circle"></i>
                                                    </NavLink>
                                                    <NavLink title="Détail"
                                                        to={`/approvisions/${appro.id}`}
                                                        state={{ appro }}
                                                        className="btn btn-sm btn-primary m-1"
                                                        onClick={() => setIdAppro(appro.id)}
                                                    >
                                                        <i className="bx bx-show"></i>
                                                    </NavLink>
                                                </>
                                            )}

                                            {!isadmin && appro.statut === 0 && (
                                                <button
                                                    className="btn btn-sm btn-success m-1"
                                                    onClick={() => handleValider(appro.id, "valider")}
                                                >
                                                    Valider
                                                </button>
                                            )}



                                            {isadmin && appro.statut === 0 && appro.confirmer === 0 && (
                                                <button
                                                    className="btn btn-sm btn-danger m-1"
                                                    onClick={() => handleValider(appro.id, "delete")}
                                                >
                                                    <i className="bx bx-trash"></i>
                                                </button>
                                            )}

                                            <button hidden
                                                className="btn btn-sm btn-primary"
                                                onClick={() =>
                                                    impression(
                                                        null,
                                                        "portrait",
                                                        `LISTE DES PRODUITS | CONTENEUR:${appro?.conteneur} | MAGASIN:${appro?.magasin}`,
                                                        appro?.produits
                                                    )
                                                }
                                            >
                                                <i className="bx bx-printer"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            ) : (
                <div className="row justify-content-center p-2 bg-danger-subtle text-danger fs-3">
                    Aucun approvisionnement trouvé!
                </div>
            )}
        </div>
    );
};

export default Approvisions;
